<template>
  <div class="teacher-bread">
    <!-- 面包屑 -->
    <shBread>
      <shBreadItem to="/">首页</shBreadItem>
      <shBreadItem>关于我们</shBreadItem>
    </shBread>
  </div>
  <div class="about">
    <img src="../../../public/imgs/about-banner-无logo.jpg" alt="" />
    <div class="logo">
      <img src="../../../public/logo/山河医学网-方形.png" alt="" />
    </div>
  </div>
  <div class="desc">
    <ShTabs v-model="activeName">
      <ShTabsPanel label="网站简介" name="3hvip">
        <div class="webname">
          <div class="webtitle">
            <h3>阜卫医考网-山河医学考试网简介（https://fuv.3hvip.cn/）</h3>
          </div>
          <div class="webdesc">
            <el-card>
              <!-- <p>
                阿虎医考网-山河医学考试网简介（https://ahu.3hvip.cn/）是中国协和医科大学出版社唯一指定的培训机构。2008年成立之初，阿虎医考图书教研工作室由数百位医学硕博组成，随后成为人民卫生出版社、中国中医药出版社的战略合作伙伴。经历了7年对考试命题规律的深度研究之后，在2015年，北京协和医学院八年制临床医学博士吴春虎携手北京大学医学部团队开始研发医考课程，基于多年医考考题的编撰经验以及对医考趋势的深度研究，阿虎医考的课程和学习方法在行业内树立了新的标杆。
              </p> -->
              <p>阜卫医考网，合肥山河教育科技有限公司旗下注册商标，致力于医学考试等大型综合性网站</p>
              <p>
                目前已覆盖110多个科目、千余门医学考培科目课程。自2014年从事医学考试项目辅导以来先后与星恒教育、人民医学网、天一医考、
                中国医药科技出版社-药师在线、英腾教育股份有限公司-考试宝典、南京时珍教育-助考之星，阿虎医考等专业医学考试厂家建立战略合作关系。从而快速地建立多方面、立体化、全方位、专业化的医学考试项目。
              </p>
              <p>目前我们已成为考试宝典A级代理商，阿虎医考金牌代理商</p>
              <p>网站已开设：</p>
              <p>
                一、以国家医学考试中心和中医药管理局中医师资格认证中心为主体的执业医师资格考试。
              </p>
              <p>
                二、由国家药品监督管理局、人力资源社会保障部组织的执业药师资格考试
              </p>
              <p>
                三、由国家卫生健康委人才交流服务中心（原中国卫生人才网）授权的行业人才考试、考核、评价等工作，比如行业准入类执业护士资格考试，水平评价类的卫生专业技术初级、中级、副高级、正高级职称考试。
              </p>

              <p>
                四、由原卫生部1993年组织、印发《关于实施临床住院医师规范化培训试行办法的通知》住院医师规范化培训，目前题库已全覆盖所有科目，视频课程正在组织上线中
              </p>
              <p>
                五、由教育主管部门组织实施的“全国硕士研究生统一招生考试”，简称“考研”，考研为选拔性考试。考研课程目前主设医学、护理类科目
              </p>
              <p>六、全国医用设备使用人员业务能力考评</p>
              <p>七、医疗招聘考试，即“考编”医学类项目</p>
              <p>
                八、卫生人才评价及其他类别，包含健康管理师三级、医学三基、
                医师定期考核、卫生人才评价等等
              </p>
              <p>
                立足当下、展望未来，我们将百倍努力、奋发向上以提供更优质课程。为建设超全专业、超强师资、超好服务而努力，愿我们终将成为<a
                  href="www.3hvip.cn"
                  >影响医学考试的力量~！！！</a
                >
              </p>
              <div class="sh-video">
                <h3>山河医学网业务宣传片</h3>
              </div>
              <div class="sh-desc">
                <video
                  controls
                  src="https://vod.3hvip.com/sv/662504d3-1947494f9e7/662504d3-1947494f9e7.mp4"
                ></video>
              </div>
            </el-card>
          </div>
        </div>
      </ShTabsPanel>
      <ShTabsPanel label="辅导项目" name="items">
        <div class="webitems">
          <p>网站已开设：</p>
          <p>
            一、以国家医学考试中心和中医药管理局中医师资格认证中心为主体的执业医师资格考试。医师资格考试的性质是行业准入考试，是评价申请医师资格者是否具备从事医师工作所必须的专业知识与技能的考试。
            考试分为两级四类，即执业医师和执业助理医师两级，每级分为临床、中医、口腔、公共卫生四类。中医类包括中医、中西医结合和民族医，其中，民族医又含蒙医、藏医、维医、傣医、朝医、壮医、哈萨克医。
          </p>
          <div class="img-items">
            <img
              src="../../../public/imgs/about-辅导项目-执业医师类.jpg"
              alt=""
            />
          </div>
          <p>
            二、由国家药品监督管理局、人力资源社会保障部组织的执业药师资格考试。执业药师
            考试亦为行业准入类考试，执业药师职业资格考试分为药学、中药学两个专业类别。
            药学类考试科目为：药学专业知识（一）、药学专业知识（二）、药事管理与法规、药学综合知识与技能四个科目，四个科目均为客观科目。
            中药学类考试科目为：中药学专业知识（一）、中药学专业知识（二）、药事管理与法规、中药学综合知识与技能四个科目，四个科目均为客观科目。目前网站已多师资、多课程、直播+录播课程全覆盖执业类考试。
          </p>
          <div class="img-items">
            <img
              src="../../../public/imgs/about-辅导项目-执业药师类.jpg"
              alt=""
            />
          </div>
          <p>
            三、由国家卫生健康委人才交流服务中心（原中国卫生人才网）授权的行业人才考试、考核、评价等系列考试，比如行业准入类执业护士资格考试，水平评价类的卫生专业技术初级、中级、副高级、正高级职称考试。
            护士执业资格考试实行国家统一考试制度，统一考试大纲，统一命题，统一合格标准，考试考核内容为“专业实务”和“实践能力”两个科目。
          </p>
          <div class="img-items">
            <img
              src="../../../public/imgs/about-辅导项目-执业护士类.jpg"
              alt=""
            />
          </div>
          <p>
            卫生系列医、药、护、技各专业的中、初级专业技术资格逐步实行以考代评和与执业准入制度并轨的考试制度，高级专业技术资格采取考试和评审结合的办法取得。卫生专业技术资格考试实行全国统一组织、统一考试时间、统一考试大纲、统一考试命题、统一合格标准的考试制度，原则上每年进行一次，卫生系列医、药、护、技各专业的中、初级专业技术资格逐步实行以考代评和与执业准入制度并轨的考试制度；用人单位根据工作需要，从获得资格证书的人员中择优聘任。
          </p>
          <span> （一）初级（士）专业考试 </span>
          <div class="img-items">
            <img
              src="../../../public/imgs/about-辅导项目-初级职称（士）类.jpg"
              alt=""
            />
          </div>
          <span> （二）初级（师）专业考试 </span>
          <div class="img-items">
            <img
              src="../../../public/imgs/about-辅导项目-初级职称（师）类.jpg"
              alt=""
            />
          </div>
          <span> （三）中级职称（中医类）专业考试 </span>
          <div class="img-items">
            <img
              src="../../../public/imgs/about-辅导项目-中级职称（中医）类.jpg"
              alt=""
            />
          </div>
          <span> （三）中级职称（临床类）专业考试 </span>
          <div class="img-items">
            <img
              src="../../../public/imgs/about-辅导项目-中级职称（临床）类.jpg"
              alt=""
            />
          </div>
          <span> （三）中级职称（护理类）专业考试 </span>
          <div class="img-items">
            <img
              src="../../../public/imgs/about-辅导项目-中级职称（护理）类.jpg"
              alt=""
            />
          </div>
          <span> （三）中级职称（医学技术）专业考试 </span>
          <div class="img-items">
            <img
              src="../../../public/imgs/about-辅导项目-中级职称（医学技术）类.jpg"
              alt=""
            />
          </div>
          <span> （三）中级职称（药学类）专业考试 </span>
          <div class="img-items">
            <img
              src="../../../public/imgs/about-辅导项目-中级职称（药学）类.jpg"
              alt=""
            />
          </div>
          <p>
            高级专业技术资格考试目前由各省自主组织考试其中副高级达线（总分数百分之六十）后方可参与评审，正高级不设分数线，根据笔试和面审综合得分择优，高级专业技术资格采取考试和评审结合的办法取得。网站题库目前一全覆盖以上考试科目，视频课程已超95%覆盖率，且正在不断组织优化更新中，卫生职称多科目直播课程开始亦为业内首创~
          </p>
          <span>
            （四）高级职称专业考试（以安徽省为例，个别省份专业设置略有差异）
          </span>
          <div class="img-items">
            <img
              src="../../../public/imgs/about-辅导项目-高级职称评审专业一览表.jpg"
              alt=""
            />
          </div>
          <p>
            四、由原卫生部1993年组织、印发《关于实施临床住院医师规范化培训试行办法的通知》住院医师规范化培训，是医学生毕业后教育的重要组成部分，主要是以临床实践、专业必修课、公共必修课专业课为培训的主要内容。目前题库已全覆盖所有科目，视频课程正在组织上线中
          </p>
          <p>
            五、由教育主管部门组织实施的“全国硕士研究生统一招生考试”，简称“考研”，考研为选拔性考试。考研课程目前主设有考研西医综合、考研护理综合、考研中医综合等~
          </p>
          <p>
            六、全国医用设备使用人员业务能力考评，原卫生部印发了《医疗器械临床使用安全管理规范（试行）》的通知（卫医管发﹝2010﹞4号）和《医疗卫生机构医学装备管理办法》的通知(卫规财发﹝2011﹞24号)，按照文件精神，医疗卫生机构应当对医用装备使用人员（包括大型医用设备相关医生、操作人员、工程技术人员）进行应用培训和考核，业务能力考评合格方可上岗操作。
          </p>
          <span> （一）大型医用设备使用人员业务能力考评专业列表 </span>
          <div class="img-items">
            <img
              src="../../../public/imgs/about-辅导项目-大型医用设备类.jpg"
              alt=""
            />
          </div>
          <p>七、医疗招聘考试，即“考编”医学类项目</p>
          <p>
            八、卫生人才评价及其他类别，包含健康管理师三级 医学三基 医师定期考核
            卫生人才评价 营养师 保育员 育婴师 小儿推拿师 产后康复师
            养老护理员（高级）等等
          </p>
        </div>
      </ShTabsPanel>
      <ShTabsPanel label="授权证书" name="auth">
        <div class="web-auth">
          <div class="title">
            <i></i>
            <h3>英腾教育-考试宝典</h3>
          </div>
          <div class="ksbao-con">
            <!-- <div></div>
            <div></div>
            <div></div> -->
            <ul>
              <li>
                <el-card>
                  <img
                    src="../../../public/auth/auth-考试宝典-山河医学网授权书.jpg"
                    alt=""
                  />
                </el-card>
                <h3>英腾教育-考试宝典授权书</h3>
              </li>
            </ul>
            <ul>
              <li>
                <el-card>
                  <img
                    src="../../../public/auth/auth-考试宝典线下体验中心.jpg"
                    alt=""
                  />
                </el-card>
                <h4>
                  英腾教育-考试宝典首家线下体验店。位于安徽阜合产业园安徽医科大学阜阳医院东门旁
                </h4>
              </li>
            </ul>
            <!-- <ul>
              <li></li>
            </ul>
            <ul>
              <li></li>
            </ul> -->
          </div>
          <div class="title">
            <i></i>
            <h3>阿虎医考</h3>
          </div>
          <div class="ahu-con">
            <ul>
              <li>
                <el-card
                  ><img
                    src="../../../public/auth/auth-阿虎医考-山河教育授权书.png"
                    alt=""
                /></el-card>
                <h3>阿虎医考授权书</h3>
              </li>
            </ul>
            <ul>
              <li>
                <el-card
                  ><img
                    src="../../../public/auth/auth-阿虎医考金牌代理商奖一.png"
                    alt=""
                /></el-card>
                <h3>阿虎医考金牌代理商奖</h3>
              </li>
            </ul>
            <ul>
              <li>
                <el-card
                  ><img
                    style="height: 350px"
                    src="../../../public/auth/auth-阿虎医考-授权书铜牌.png"
                    alt=""
                /></el-card>
                <h3>阿虎医考铜牌授权书</h3>
              </li>
            </ul>
            <ul>
              <li>
                <el-card
                  ><img
                    style="height: 350px"
                    src="../../../public/auth/auth-阿虎医考-金牌代理商领奖.jpg"
                    alt=""
                /></el-card>
                <h5>
                  阿虎医考总裁顾连强（右一）为网站创始人之一小刘老师（右二）颁奖、合影，左一为阿虎医考创始人吴春虎先生
                </h5>
              </li>
            </ul>
          </div>
          <div class="title">
            <i></i>
            <h3>时珍教育-助考之星</h3>
          </div>
          <div class="zhukao-con">
            <ul>
              <li>
                <el-card>
                  <img
                    src="../../../public/auth/auth-助考之星-山河医学网授权书.jpg"
                    alt=""
                  />
                </el-card>
                <h3>助考之星-山河医学网授权书</h3>
              </li>
            </ul>
          </div>
        </div>
      </ShTabsPanel>
      <ShTabsPanel label="联系我们" name="contact">
        <div class="contact">
          <div class="contact-title">
            <h3>联系我们</h3>
          </div>
          <div class="content">
            <ShVip />
            <KsbVip />
          </div>
        </div>
      </ShTabsPanel>
      <ShTabsPanel label="合作伙伴" name="partner">
        <div class="partner">
          <h3>合作伙伴宣传片</h3>
          <div class="par-desc">
            <video
              src="https://vod.3hvip.com/sv/15e17203-1947494cc4b/15e17203-1947494cc4b.mp4"
              controls
              type="video/mp4"
            ></video>
          </div>
          <div class="par-items">
            <div class="par-ksbao">
              <div class="par-title">
                <i></i>
                <h3>英腾教育-考试宝典</h3>
              </div>
              <div class="ksbao-desc">
                <p>
                  考试宝典、英腾教育科技股份有限公司旗下医学考试品牌，中国高科集团股份有限公司全资子公司，2009年，荣获国家级《高新技术企业证书》；全国率先发布《医学高级职称》系列产品。
                </p>
                <p>2005年，广西英腾教育科技股份有限公司成立</p>
                <p>2008年，进驻柳州市高新区信息产业园。</p>
                <p>2009年，荣获国家级《高新技术企业证书》</p>
                <p>
                  2011年，通过国家级“双软企业”认证，
                  《在线医学学习及考试系统》项目荣获国家科技部中小企业技术创新基金
                </p>
                <p>
                  2015年在“中国硅谷”中关村成立英腾智库研发中心，年营收达1500万元。
                </p>
                <p>
                  2017年，中国高科集团股份有限公司收购广西英腾教育科技股份有限公司51%的股份。成为中国高科集团全资子公司
                </p>
                <p>
                  2021年企业转型升级，由医学教育向职业教育全线扩张，在武汉光谷成立研发基地，员工400余人。
                </p>
                <p>
                  创始人
                  兰涛，1997年毕业于华中科技大学同济医学院（原同济医科大学），中国高科集团董事会董事、副总经理、代行总经理、广西英腾教育科技股份有限公司董事长
                </p>
              </div>
            </div>
            <div class="par-ksbao">
              <div class="par-title">
                <i></i>
                <h3>阿虎医考</h3>
              </div>
              <div class="ksbao-desc">
                <p>
                  北京阿虎科技有限公司成立于2015年，由北京协和医学院博士和北京大学医学院医学团队创办，经过数年磨砺与创新，开发了属于自己的线上学习平台和智能移动学习平台。
                </p>
                <p>
                  阿虎医考深耕医考培训领域多年，从2008年开始成为各大医学出版社考纲官方教辅指定供应商，我们竭尽所能做好内容和产品，为医考赋能，让医考变得简单！
                </p>

                <p>创始人 吴春虎</p>
                <p>北京协和医学院（清华大学医学部）八年制临床医学博士</p>
                <p>
                  原卫生部临床医生科普项目“百科名医网”创始合伙人
                  （“字节跳动”收购）
                </p>
                <p>原红杉投资“掌上药店”合伙人，CMO</p>
                <p>16年图书出版与医学培训经验、人民卫生出版社社外专家</p>
              </div>
            </div>
            <div class="par-ksbao">
              <div class="par-title">
                <i></i>
                <h3>助考之星</h3>
              </div>
              <div class="ksbao-desc">
                <p>
                  助考之星/助考宝典（商标号14731019）：是南京时珍教育科技有限公司持有注册商标，
                  为医护人员提供优质体验的学习辅导产品。
                </p>
                <p>
                  本产品是由大学出版社河海大学出版社、南京大学出版社出版、
                  2009年南京时珍教育科技有限公司研发的专业考试学习软件。
                </p>
                <p>
                  十余年来，【助考之星】已帮助众多卫生从业人员通过各类卫生职称考试，使其成为专业的医师、药师、护师和技师。
                </p>
              </div>
            </div>
          </div>
        </div>
      </ShTabsPanel>
    </ShTabs>
  </div>
</template>

<script>
import ShVip from "./compontents/shvip";
import KsbVip from "./compontents/ksbvip";
import { ref } from "vue";
export default {
  components: { ShVip, KsbVip },
  setup() {
    const activeName = ref("3hvip");
    return { activeName };
  },
};
</script>

<style lang="less" scoped>
.teacher-bread {
  background: @shColor;
}
.about {
  position: relative;

  .logo {
    position: absolute;
    width: 200px;
    height: 200px;
    top: 5%;
    left: 50%;
    margin-left: -118px;
  }
}
.desc {
  width: 1240px;
  margin: 0 auto;
  .webname {
    //height: 2380px;
    margin-top: 25px;
    .webtitle {
      display: flex;
      height: 50px;
      justify-content: center;
      align-items: center;
    }
    .webdesc {
      margin: 15px 25px 15px 25px;
      p {
        font-size: 18px;
        color: #555;
        padding: 25px 15px 25px 15px;
        a {
          color: @shColor;
          font-weight: bold;
        }
      }
      .sh-video {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
        background: rgb(245, 245, 245);
      }
      .sh-desc {
        display: flex;
        justify-content: center;

        video {
          width: 910px;
          height: 540px;
        }
      }
    }
  }
  .webitems {
    padding-bottom: 15px;
    p {
      font-size: 18px;
      line-height: 30px;
      color: #555;
      padding: 25px 15px 25px 15px;
    }
    span {
      display: block;
      text-align: center;
      color: @shColor;
      font-size: 16px;
      margin-top: 15px;
      margin-bottom: 15px;
      font-weight: 800;
    }
    .img-items {
      display: flex;
      justify-content: center;
    }
  }
  .web-auth {
    height: 3100px;
    .title {
      display: flex;
      align-items: center;
      margin-top: 15px;
      height: 50px;
      background: rgb(245, 245, 245);
      i {
        display: block;
        width: 3px;
        height: 20px;
        background: @shColor;
      }
      h3 {
        margin-left: 15px;
      }
    }
    .ksbao-con {
      display: flex;
      justify-content: space-around;
      width: 1220px;
      height: 750px;
      margin: 0 auto;
      margin-top: 15px;
      //border-radius: 8px;

      ul {
        width: 500px;
        height: 700px;
        //background: rgb(245, 245, 245);
        border-radius: 8px;
        padding-top: 50px;
        img {
          width: 500px;
          height: 600px;
          border-radius: 8px;
        }
        h3 {
          text-align: center;
          line-height: 50px;
        }
      }
    }
    .ahu-con {
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      width: 1220px;
      height: 1330px;
      margin: 0 auto;
      margin-top: 15px;
      ul {
        display: flex;
        justify-content: center;
        width: 550px;
        height: 770px;
        margin-top: 55px;
        //background: rgb(245, 245, 245);
        border-radius: 8px;
        img {
          //width: 550px;

          height: 720px;
          border-radius: 8px;
        }
        h3 {
          text-align: center;
          line-height: 50px;
        }
      }
    }
    .zhukao-con {
      display: flex;
      justify-content: center;
      width: 1220px;
      height: 750px;
      margin: 0 auto;
      margin-top: 15px;
      //border-radius: 8px;

      ul {
        width: 500px;
        height: 700px;
        //background: rgb(245, 245, 245);
        border-radius: 8px;
        padding-top: 50px;
        img {
          width: 500px;
          height: 600px;
          border-radius: 8px;
        }
        h3 {
          text-align: center;
          line-height: 50px;
        }
      }
    }
  }
  .contact {
    .contact-title {
      height: 50px;
      h3 {
        line-height: 50px;
        text-align: center;
      }
    }
    .content {
      display: flex;
      justify-content: space-around;
      margin-bottom: 15px;
      //margin: 15px 20px 15px 20px;
    }
  }
  .partner {
    h3 {
      margin-top: 15px;
      margin-bottom: 25px;
      text-align: center;
    }
    .par-desc {
      display: flex;
      justify-content: center;
      border-radius: 8px;
      video {
        width: 910px;
        height: 540px;
        border-radius: 8px;
      }
    }
    .par-items {
      .par-ksbao {
        .par-title {
          display: flex;
          align-items: center;
          margin-top: 15px;
          height: 50px;
          background: rgb(245, 245, 245);
          i {
            display: block;
            height: 20px;
            width: 3px;
            background: @shColor;
          }
          h3 {
            margin-left: 15px;
            align-self: baseline;
          }
        }
        .ksbao-desc {
          p {
            padding: 10px 15px 15px 15px;
            font-size: 15px;
          }
        }
      }
    }
  }
}
</style>
